/**
 * Quick Create: every skill and agent, ready to start. The server already
 * leaves out what the viewer's role may not start (a client or a Viewer sees
 * the skills only).
 */
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import type { WorkshopQuickCreateItem } from "@/types/workshop.type";
import { workshopQuickCreateKey } from "./workshopKeys";

export type WorkshopQuickCreateList = {
  items: WorkshopQuickCreateItem[];
};

export function useWorkshopQuickCreate(brandId: string | null) {
  return useQuery({
    queryKey: workshopQuickCreateKey(brandId),
    queryFn: async () => {
      const res = await axiosInstance.get<WorkshopQuickCreateList>(`/workshop/brand/${brandId}/quick-create`);
      return res.data;
    },
    enabled: !!brandId,
    // The list changes only when someone edits a skill or agent in the CMS.
    staleTime: 5 * 60_000,
  });
}
